module.exports = __webpack_public_path__ + "img/pressingKnife1.03a6b255.png";